import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from '../../locales/en.json';
import viTranslation from '../../locales/vi.json';

const resources = {
  en: {
    translation: enTranslation
  },
  vi: {
    translation: viTranslation
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('i18nextLng') || 'vi', // Default language from localStorage or 'en'
    fallbackLng: 'vi',
    interpolation: {
      escapeValue: false
    }
  });

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
});

export default i18n; 